import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import useDeepCompareEffect from 'use-deep-compare-effect';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import IconSettingClass from '../../../../../../components/settingsIcon';
import { getNJCertifiedSettings, saveNJCertifiedSettings } from '../../../../../../store/actions';
import EarningCodes from './earningCodes';
import EmployeeSettings from './employee';
import CostCenter from './costCenter';
import { isEmpty, isEqual, set } from 'lodash';

const NJCertifiedSettings = props => {
    const [CPSettings, setCPSettings] = useState({});
    const [mappedEarningCodes, setMappedEC] = useState([]);
    const [jobTitleSource, setJobTitleSource] = useState("");
    const [jobTitleField, setJobTitleField] = useState("");
    const [workClsfctnSource, setWorkClsfctnSource] = useState("");
    const [workClsfctnField, setWorkClsfctnField] = useState("");
    const [costCenterTreeName, setCostCenter] = useState("");
    const [taxSavedReportId, setTaxSavedReportId] = useState("");
    const [saveEnabled, setEnable] = useState(false);
    const [changesTracker, setChanges] = useState({});


    useDeepCompareEffect(() => {
        async function getSettings() {
            await props.getNJCertifiedSettings(props.ClientDataReducer.companyShortName);
            let { jobTitleField, workClsfctnSource, workClsfctnField, costCenterTreeName, jobTitleSource, taxSavedReportId } = props.NJCertifiedSettingsReducer;
            setJobTitleField(jobTitleField);
            setWorkClsfctnSource(workClsfctnSource);
            setWorkClsfctnField(workClsfctnField);
            setCostCenter(costCenterTreeName);
            setJobTitleSource(jobTitleSource);
            setTaxSavedReportId(taxSavedReportId);
            setCPSettings({ ...props.NJCertifiedSettings });
            mapCodes();
        };
        getSettings();
        compareChanges();
    }, [CPSettings, mappedEarningCodes]);

    useEffect(() => {
        compareChanges()
    }, [
        jobTitleField,
        workClsfctnSource,
        workClsfctnField,
        costCenterTreeName
    ]);

    function compareChanges() {
        let changes = {
            costCenterTreeName,
            jobTitleField,
            workClsfctnSource,
            workClsfctnField,
            earningCodes: mappedEarningCodes.filter(mec => mec.earningType).map(ec => {
                let e = { code: ec._id, earningType: ec.earningType };
                if (ec.ecId) e._id = ec.ecId;
                return e;
            })
        };
        let hasChanges = false;
        let changesObj = {};
        for (let key in changes) {
            if (!isEqual(changes[key], CPSettings[key])) {
                hasChanges = true;
                changesObj[key] = changes[key];
                if (changesObj.hasOwnProperty(key) && (changesObj[key] === undefined || changesObj[key] === "")) changesObj[key] = null;
            };
        };
        setChanges({ ...changesObj });
        setEnable(hasChanges);
    }

    async function updateSettings() {
        let query = {
            companyId: props.ClientDataReducer.companyId
        };
        let update = { ...changesTracker };
        if (!CPSettings.companyShortName) update.companyShortName = props.ClientDataReducer.companyShortName;
        if (!isEmpty(update)) {
            try {
                await props.saveNJCertifiedSettings({ query, update });

            } catch (error) {
                console.log(error);
            };
        };
    };

    function mapCodes() {
        let mappedEarningCodes = props.EarningCodeReducer.map(ec => {
            let inSettings = props.NJCertifiedSettingsReducer.earningCodes && props.NJCertifiedSettingsReducer.earningCodes.find(ecd => ecd.code === ec._id);
            if (inSettings) {
                ec = { ...ec, earningType: inSettings.earningType, ecId: inSettings._id };
            }
            return ec;
        });
        let mapped = [...mappedEarningCodes]
        setMappedEC(mapped);
    };

    function changeEarningCode() {
        compareChanges()
    }

    function onValueChange(val, field) {
        switch (field) {
            case "jobTitleField": {
                setJobTitleField(val);
                break;
            }
            case "workClsfctnField": {
                setWorkClsfctnField(val);
                break;
            };
            case "workClsfctnSource": {
                setWorkClsfctnSource(val.value);
                break;
            };
            case "costCenterParent": {
                setCostCenter(val.key);
                break;
            };
            case "taxReportId": {
                setTaxSavedReportId(val);
                break;
            }
            case "jobTitleSource": {
                setJobTitleSource(val.value);
                break;
            };
        };
        compareChanges();
    };

    return (
        <Accordion>
            <AccordionSummary
                expandIcon={<IconSettingClass />}
                aria-controls="panel1a-content"
                id="panel1a-header"
            >
                <Typography className="reportTitle">NJ Certified payroll report</Typography>
            </AccordionSummary>

            <AccordionDetails>
                <div className="reportListAccording mar-0">
                    <div className="df align-items-center justify-content-between margin-top-10">
                        <button
                            className="btn reportBtn"
                            onClick={updateSettings}
                            disabled={!saveEnabled}
                        >
                            Save
                        </button>
                    </div>
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <Typography className="titleAccording">Pay Codes</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <EarningCodes
                                mappedEarningCodes={[...mappedEarningCodes]}
                                onTypeChange={changeEarningCode}
                            ></EarningCodes>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <Typography className="titleAccording">Report Settings</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <EmployeeSettings
                                jobTitleField={jobTitleField}
                                jobTitleSource={jobTitleSource}
                                workClsfctnField={workClsfctnField}
                                workClsfctnSource={workClsfctnSource}
                                costCenterTreeName={costCenterTreeName}
                                taxSavedReportId={taxSavedReportId}
                                onChange={onValueChange}
                            ></EmployeeSettings>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <Typography className="titleAccording">Cost Center (Job) Settings</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <CostCenter
                                costCenters={props.PARENT_COST_CENTERS}
                                costCenterTreeName={costCenterTreeName}
                                onChange={onValueChange}></CostCenter>
                        </AccordionDetails>
                    </Accordion>
                </div>
            </AccordionDetails>
        </Accordion>
    )
};

const mapStateToProps = ({ UserReducer, ClientDataReducer, EarningCodeReducer, CostCenterReducer, NJCertifiedSettingsReducer }) => {
    let { PARENT_COST_CENTERS } = CostCenterReducer;
    return { UserReducer, ClientDataReducer, EarningCodeReducer, PARENT_COST_CENTERS, NJCertifiedSettingsReducer };
};

export default connect(mapStateToProps, {
    getNJCertifiedSettings,
    saveNJCertifiedSettings
})(NJCertifiedSettings); // Remove saveCertifiedSettings